import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import Landing from './Pages/LandingPage'
import Dashboard from './Pages/Dashboard'
import Login from './Pages/Login';
import Register from './Pages/Register';

import FogetPassword from './Pages/FogetPassword';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Landing} />
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={FogetPassword} />
          <Route path="/register" component={Register} />
          <Route path="/dashboard" component={Dashboard} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
